module.exports = __webpack_public_path__ + "img/auth.9c640cce.jpg";